<template>
  <div :class="{'hide-last-pager': hideLastPager}">
    <kr-data-table
      :prohibitUploading="prohibitUploading"
      :notip="notip"
      :uploadType="uploadType"
      ref="krDataTable"
      :noLoading="noLoading"
      v-bind="$attrs"
      :expand-details="expandDetails"
      :show-set-header="showSetHeader"
      :emit-filter="emitFilter"
      :edit-click="editClick"
      :is-single="isSingle"
      :edit-show="editShow"
      :layout-type="layoutType"
      :selectable="selectable"
      :check-box-all-show="checkBoxAllShow"
      :lock="lock"
      @end="$emit('end')"
      @onFilter="handleFilter"
      @cellClick="cellClick"
      @checkboxChange="checkboxChange"
      @getSelectionRows="getSelectionRows"
      @handelHeaderCheckbox="handelHeaderCheckbox"
      @handleSetHeader="handleSetHeader"
      @metadataChange="metadataChange"
      @pageChange="handlePagechange"
      @favouriteClick="favouriteClick"
      @referenceClick="referenceClick"
      @relatedClick="relatedClick"
      @settingsClick="settingsClick"
      @headerDragend="handleHeaderDragend"
      @sortChange="sortChange"
      @popoverTable="popoverTable"
      :id="id"
      :apiName="apiName"
    />
    <el-popover
      ref="popover"
      v-model="isShowPopover"
      :popper-options="{ onUpdate: popoverUpdate }"
      :reference="reference"
      :placement="tableMetas.placement"
      :width="tableMetas.width"
      :popper-class="tableMetas.popperClass"
      trigger="click"
    >
      <kr-data-table
        :prohibitUploading="prohibitUploading"
        :notip="notip"
        v-if="isShowPopover"
        :noLoading="noLoading"
        :metas="tableMetas"
        :popover="$refs.popover"
        :show-set-header="showSetHeader"
        :hide-empty-image="true"
        @settingsClick="settingsClick(...arguments, true)"
        @handleSetHeader="handleSetHeader(...arguments, true)"
        @pageChange="handlePagechange(...arguments, true)"
        :id="id"
        :apiName="apiName"
      />
    </el-popover>

    <el-popover
      ref="manualPopover"
      v-model="showManPopover"
      :reference="manualReference"
      :placement="tableMetas.placement"
      :width="tableMetas.width"
      :title="tableMetas.title"
      :popper-class="tableMetas.popperClass"
      trigger="manual"
    >
      <div
        class="close-popover"
        :class="{'margin': tableMetas.type === 'normal'}"
      >
        <i
          class="icon iconfont icon-cross close-icon"
          @click="hideMannualPopover"
        />
      </div>
      <kr-data-table
        :prohibitUploading="prohibitUploading"
        :notip="notip"
        v-if="tableMetas.type === 'normal'"
        :metas="tableMetas"
        :noLoading="noLoading"
        :popover="$refs.popover"
        :show-set-header="showSetHeader"
        @settingsClick="settingsClick(...arguments, true)"
        @handleSetHeader="handleSetHeader(...arguments, true)"
        @pageChange="handlePagechange(...arguments, true)"
        :id="id"
      />
      <kr-related-table
        v-if="tableMetas.type === 'related'"
        :options="tableMetas"
        @settingsClick="settingsClick(...arguments)"
        @handleSetHeader="handleSetHeader(...arguments)"
      />
    </el-popover>
  </div>
</template>
<script>
/*  eslint-disable */
import { queryDataFromServerApi } from '@inv/services/metaData';
import KrDataTable from '../krDataTable';
import KrRelatedTable from '../krRelatedTable';

export default {
  name: 'KrDataTables',
  props: {
    prohibitUploading: {
      type: Boolean,
      default: false,
    },
    notip: {
      type: Boolean,
      default: false,
    },
    id: kr.vue.getPropString(),
    apiName:{
      type: String,
      default: ""
    },
    // 判断是否为文件上传弹窗组件里面的表格
    uploadType:{
      type: Object,
      default: () => ({})
    },
    noLoading: kr.vue.getPropBoolean(false),
    expandDetails: kr.vue.getPropObject(),
    popoverTableMetas: kr.vue.getPropObject(),
    showSetHeader: kr.vue.getPropBoolean(true),
    emitFilter: kr.vue.getPropBoolean(false),
    isSingle: kr.vue.getPropBoolean(false),

    hideLastPager: {
      type: Boolean,
      default: false,
    },
    editClick: Function,
    editShow: Boolean,
    layoutType: kr.vue.getPropString(),
    checkBoxAllShow: kr.vue.getPropBoolean(false),
    selectable: Function,
    lock: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      reference: null,
      manualReference: null,
      tableMetas: {},
      showManPopover: false,
      isShowPopover: false,
    };
  },
  components: {
    KrDataTable,
    KrRelatedTable,
  },
  created() {
    // console.log(this.metas);
  },
  created() {
    this.tableMetas = this.popoverTableMetas;
  },
  methods: {
    popoverUpdate(data) {
      // console.log('xxxxx', data);
      // this.$refs.popover.updatePopper();
    },
    getKrDataTable() {
      const { krDataTable } = this.$refs;
      return krDataTable;
    },
    getKrTable() {
      const { krDataTable } = this.$refs;
      return krDataTable.getKrTable();
    },
    getSelectionRows(rows) {
      this.$emit('getSelectionRows', rows);
    },
    handleSetHeader(viewFields, popover) {
      this.$emit('handleSetHeader', viewFields, popover);
    },
    handlePagechange(pageInfo, popover) {
      this.$emit('pageChange', pageInfo, popover);
    },
    cellClick(data) {
      this.$emit('cellClick', data);
    },
    checkboxChange(...arg) {
      this.$emit('checkboxChange', ...arg);
    },
    metadataChange(meta) {
      this.$emit('metadataChange', meta);
    },
    sortChange(sortParams) {
      this.$emit('sortChange', sortParams);
    },
    handelHeaderCheckbox(...arg) {
      this.$emit('handelHeaderCheckbox', ...arg);
    },
    handleHeaderDragend(...arg) {
      this.$emit('headerDragend', ...arg);
    },
    popoverTable(item, row, relation, relationAttrs, e) {
      const { tableMetas } = this;
      if (item.type && item.type === 'version') {
        const option = relationAttrs.reduce((per, item) => {
          per[item] = row[item];
          return per;
        }, {});

        this.tableMetas = {
          placement: 'bottom',
          api: queryDataFromServerApi(relation),
          opt: option,
        };
        this.showPopover(e);
      } else {
        tableMetas.opt.data = {
          id: row.id,
          row,
        };
        this.tableMetas = Object.freeze(tableMetas);
        this.showPopover(e);
      }
    },
    favouriteClick(e, row) {
      this.$emit('favouriteClick', row);
    },
    referenceClick(e, field) {
      if (this.showManPopover) {
        return;
      }
      this.$emit('referenceClick', field);
      this.$watch('popoverTableMetas', (val) => {
        this.tableMetas = val;
        if (this.tableMetas.manual) {
          this.showMannualPopover(e);
        } else {
          this.showPopover(e);
        }
      });
    },
    relatedClick(e, row) {
      if (this.showManPopover) {
        return;
      }
      this.$emit('relatedClick', row);
      this.$watch('popoverTableMetas', (val) => {
        this.tableMetas = val;
        this.showMannualPopover(e);
      });
    },
    settingsClick(opt, command, relation, relationAttrs, popover) {
      // const { key, row } = opt;
      this.$emit('settingsClick', opt, command, popover);
    },
    showPopover(e) {
      const {moduleInfoId} = this.$route.params
      if(moduleInfoId !== "vote_result__u"){
        if (this.isShowPopover) {
        this.$refs.popover.doClose();
        this.reference = null;
        this.$refs.popover.referenceElm = null;
        this.isShowPopover = false;
        }
        if (this.__showPopoverTimer) {
          clearTimeout(this.__showPopoverTimer)
        }
        this.__showPopoverTimer = setTimeout(() => {
          this.reference = e.target;
          this.$refs.popover.referenceElm = e.target;
          this.hideMannualPopover();
          this.$refs.popover.updatePopper();
          this.$refs.popover.doShow();
          this.isShowPopover = true;
        }, 300);
      }
    },
    showMannualPopover(e) {
      if (this.showManPopover) {
        this.hideMannualPopover();
      }
      this.reference = e.target;
      this.$refs.manualPopover.referenceElm = e.target;
      this.$nextTick(() => {
        this.$refs.popover.doClose();
        this.$refs.manualPopover.updatePopper();
        this.showManPopover = true;
      });
    },
    hideMannualPopover() {
      this.manualReference = null;
      this.$refs.manualPopover.referenceElm = null;
      this.showManPopover = false;
    },
    handleFilter(val, source) {
      if (this.emitFilter) {
        this.$emit('onFilter', val, source);
      }
    },
  },
};
</script>

<style lang="scss">
.hide-last-pager {
  .el-pager {
    > li.btn-quicknext.more ~ li {
      display: none;
    }
  }
}

.close-popover {
  float: right;
  margin-left: -20px;
  margin-top: 2px;
  cursor: pointer;
  z-index: 10010;
  position: relative;

  &.margin {
    margin-top: -35px;
  }

  .close-icon {
    font-size: 20px;
    color: #969fa9;

    &:hover {
      color: $color-hover-primary;
    }
  }
}
</style>
